import {Component, Input, OnInit} from '@angular/core';
import {TooltipService} from '../../services/tooltip-service';

@Component({
    selector: 'app-tooltip-cont',
    templateUrl: './tooltip.component.html'
})

export class TooltipComponent implements OnInit{
    @Input() key:string;
    @Input() label:string;

    tooltipTitle: string;
    hasLabel=false;

    constructor(private tooltipService: TooltipService) {
    }

    ngOnInit() {
        this.hasLabel = (this.label && this.label != null && this.label != '');
        if(this.key && this.key != null && this.key != '') {
            this.tooltipService.getTooltip(this.key).then(data => data!=null ? this.tooltipTitle = data.value: this.tooltipTitle='');
        }
    }
}
